// src/fonts.js
import localFont from 'next/font/local'

// toyota (only one weight)
const toyota = localFont({
  src: [
    {
      path: '../public/fonts/toyota/light.otf',
      weight: '300',
      style: 'normal'
    }
  ],
  variable: '--font-toyota',
  display: 'swap'
})

const toyotaMM21 = localFont({
  src: [
    {
      path: '../public/fonts/toyota/Toyota-Regular.otf',
      weight: '300',
      style: 'normal'
    },
    {
      path: '../public/fonts/toyota/Toyota-Semibold.otf',
      weight: '700',
      style: 'normal'
    }
  ],
  variable: '--font-toyota-mm21',
  display: 'swap'
})

const lexusMM21 = localFont({
  src: [
    {
      path: '../public/fonts/lexus/mm-lexus-Regular.otf',
      weight: '300',
      style: 'normal'
    },
    {
      path: '../public/fonts/lexus/mm-lexus-Semibold.otf',
      weight: '700',
      style: 'normal'
    }
  ],
  variable: '--font-lexus-mm21',
  display: 'swap'
})

// lexus (light + bold)
const lexus = localFont({
  src: [
    {
      path: '../public/fonts/lexus/light.otf',
      weight: '300',
      style: 'normal'
    },
    {
      path: '../public/fonts/lexus/regular.otf',
      weight: '700',
      style: 'normal'
    }
  ],
  variable: '--font-lexus',
  display: 'swap'
})

const lexusAlternative = localFont({
  src: [
    {
      path: '../public/fonts/lexus/arial-light.ttf',
      weight: '300',
      style: 'normal'
    }
  ],
  variable: '--font-lexus-alt',
  display: 'swap'
})

const toyotaMM21Icons = localFont({
  src: [
    {
      path: '../public/fonts/toyota/mm21-toyota-icons.woff',
      weight: '400',
      style: 'normal'
    }
  ],
  display: 'swap',
  variable: '--font-icons-toyota-mm21'
})

const lexusMM21Icons = localFont({
  src: [
    {
      path: '../public/fonts/lexus/mm21-lexus-icons.woff',
      weight: '400',
      style: 'normal'
    }
  ],
  display: 'swap',
  variable: '--font-icons-lexus-mm21'
})

const sharedMM21Icons = localFont({
  src: [
    {
      path: '../public/fonts/mm21-shared-icons.woff',
      weight: '400',
      style: 'normal'
    }
  ],
  display: 'swap',
  variable: '--font-icons-shared-mm21'
})

const customFonts = {
  lexusMM21,
  toyotaMM21,
  toyota,
  lexus,
  lexusAlternative,
  toyotaMM21Icons,
  lexusMM21Icons,
  sharedMM21Icons
}

export default customFonts
